import difficultyLevels from '@website/dataObjects/difficultyLevels';

export default function useSelectedDifficultLevelDetails(level: string) {
  return difficultyLevels.find(({ value }) => {
    return value === parseInt(level);
  });
}
